module.exports = __webpack_public_path__ + "static/img/check.43e0d8ad.svg";